// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Nunito:300,600,700&display=swap);"]);
// Module
exports.push([module.id, ".ConfirmModal{width:90%;max-width:668px}.img-overlay{background-color:rgba(39,44,52,0.419608);width:100%;height:100%;display:flex;justify-content:center;align-items:center}.img-overlay span{font-size:26px;color:#fefeff;font-weight:900}\n", ""]);
// Exports
module.exports = exports;
